import React from "react";

export function ImageModalCircle() {
    return (
      <svg width="126" height="120" viewBox="0 0 126 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="63" cy="60" r="55" fill="#FFEADE" fillOpacity="0.5" />
        <mask id="mask0_11962_3003" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="8" y="5" width="110" height="110">
          <circle cx="63" cy="60" r="55" fill="#F2EFEE" />
        </mask>
        <g mask="url(#mask0_11962_3003)">
          <path d="M70.2139 131.806L-6.85754 54.7344C-27.7885 76.045 -27.6712 110.288 -6.50557 131.454C14.66 152.62 48.9033 152.737 70.2139 131.806Z" stroke="#FF7020" />
        </g>
        <path d="M100.292 50.0001C111.913 50.0001 121.333 40.5794 121.333 28.9584C121.333 17.3374 111.913 7.91675 100.292 7.91675C88.6707 7.91675 79.25 17.3374 79.25 28.9584C79.25 40.5794 88.6707 50.0001 100.292 50.0001Z" fill="#FF7020" />
        <path d="M94.4587 13.7501C97.7954 13.7501 100.5 11.0451 100.5 7.70841C100.5 4.37169 97.7954 1.66675 94.4587 1.66675C91.1219 1.66675 88.417 4.37169 88.417 7.70841C88.417 11.0451 91.1219 13.7501 94.4587 13.7501Z" stroke="#060505" />
        <path d="M97.5762 112.518C102.368 112.518 106.252 108.641 106.252 103.86C106.252 99.0786 102.368 95.2025 97.5762 95.2025C92.7847 95.2025 88.9004 99.0786 88.9004 103.86C88.9004 108.641 92.7847 112.518 97.5762 112.518Z" stroke="#FF7020" strokeMiterlimit="10" />
      </svg>
    )
}